<template>
  <div class="footer" v-if="barShow">
    <div class="foot-item"  v-track="{functionName: '首页'}" @click="handleClick('home')">
      <div class="foot-img">
        <img src="../assets/images/common/icon-indexed.png" v-if="routeText === '/' || routeText === '/home'" class="img"
          alt="">
        <img src="../assets/images/common/icon-index.png" v-else class="img" alt="">
      </div>
      <div class="foot-txt" :class="routeText === '/' || routeText === '/home' ? 'cur' : ''">首页</div>
    </div>
    <div class="foot-item"  v-track="{functionName: '直播'}" @click="handleClick('liveList')">
      <div class="foot-img">
        <img src="../assets/images/common/icon-liveed.png" v-if="routeText.indexOf('/liveList') > -1" class="img" alt="">
        <img src="../assets/images/common/icon-live.png" v-else class="img" alt="">
      </div>
      <div class="foot-txt" :class="routeText.indexOf('/liveList') > -1 ? 'cur' : ''">直播</div>
    </div>
    <div class="foot-item"  v-track="{functionName: '学习日历'}" @click="handleClick('calendar')">
      <div class="foot-img">
        <img src="../assets/images/common/icon-calendared.png" v-if="routeText.indexOf('/cartoDate') > -1 || routeText.indexOf('/cartoDate') > -1" class="img" alt="">
        <img src="../assets/images/common/icon-calendar.png" v-else class="img" alt="">
      </div>
      <div class="foot-txt" :class="routeText.indexOf('/cartoDate') > -1 || routeText.indexOf('/cartoDate') > -1 ? 'cur' : ''">学习日历</div>
    </div>
    <div class="foot-item"  v-track="{functionName: '我的'}" @click="handleClick('person')">
      <div class="foot-img">
        <img src="../assets/images/common/icon-personed.png" v-if="routeText.indexOf('/person') > -1" class="img" alt="">
        <img src="../assets/images/common/icon-person.png" v-else class="img" alt="">
      </div>
      <div class="foot-txt" :class="routeText.indexOf('/person') > -1 ? 'cur' : ''">我的</div>
    </div>
  </div>
</template>
<script>
import { BOOL_GOAL, BOOL_SENIOR_EMPLOYEE } from '@/utils/configRoles'
import { WHITE_PATHS } from '@/store/mutation-types'
export default {
  name: 'bar',
  data () {
    return {
      BOOL_GOAL,
      BOOL_SENIOR_EMPLOYEE,
      barShow: true
    }
  },
  computed: {
    routeText () {
      return this.$route.path
    }
  },
  mounted () {
    if (WHITE_PATHS.indexOf(this.$route.path) !== -1) {
      this.barShow = false
    }
  },
  methods: {
    handleClick (type) {
      switch (type) {
        case 'home':
          this.$router.push({
            path: '/home'
          })
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/home`)
          break
        case 'liveList':
          this.$router.push({
            path: '/liveList'
          })
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/liveList`)
          break
        case 'calendar':
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/cartoDate`)
          this.$router.push({
            path: '/cartoDate'
          })
          break
        case 'person':
          this.$router.push({
            path: '/person'
          })
          localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/person`)
          break

        default:
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.footer {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 50px;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-shadow: 0px 0px 0px 1px rgba(220, 220, 220, 0.5);
  z-index: 998;

  .foot-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .foot-txt {
      line-height: 10px;
      font-size: 10px;
      font-weight: 500;
      text-align: center;
      margin-top: 6px;

      &.cur {
        color: #EB1700;
      }
    }

    .foot-img {

      .img {
        width: auto;
        height: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/barComponents.vue